import { useEffect, useRef } from 'react';

const FIRST_FIELD = 'input:not([type="hidden"]), select, textarea';

/**
 * Keyboard focus for an inline-edit section: into the first field when the form
 * opens, to the invalid field when a save fails, and back onto the Edit button
 * when the form closes, so a keyboard user is never dropped to the page top.
 */
export function useEditSectionFocus(showForm: boolean, failures: number) {
  const formRef = useRef<HTMLDivElement>(null);
  const editRef = useRef<HTMLButtonElement>(null);
  const wasOpen = useRef(false);

  useEffect(() => {
    if (showForm && !wasOpen.current) {
      formRef.current?.querySelector<HTMLElement>(FIRST_FIELD)?.focus();
    }
    if (!showForm && wasOpen.current) editRef.current?.focus();
    wasOpen.current = showForm;
  }, [showForm]);

  useEffect(() => {
    if (failures === 0) return;
    const invalid = formRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]');
    invalid?.focus();
  }, [failures]);

  return { formRef, editRef };
}
